import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, LineElement, PointElement } from "chart.js";
import { Pie, Bar, Line } from "react-chartjs-2";
import { Box, Typography } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, LineElement, PointElement);

const ChartDisplay = ({ chartType, data, options, title, columns }) => {
  
  const filteredColumn = [
    {columns: "año"},
    {columns: "mes"},
    {columns: "día"},
  ];
  const columnNames = filteredColumn.map(item => item.columns);
  return (
    <Box sx={{ width: "100%", mt: 3 }}>

      <Typography variant="h6" sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}>
        {title}
      </Typography>
      {chartType === "pie" && <Pie data={data} options={options} />}
      {chartType === "bar" && <Bar data={data} options={options} />}
      {chartType === "line" && <Line data={data} options={options} />}

    </Box>
  );
};

export default ChartDisplay;
